import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // Assuming you are using react-router for routing
import Logo from '../Resource/Logo.png';

const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div>
    <div className="text-center py-2">
        <img src={Logo} alt="Logo" className=" h-28 w-28 mx-auto" />
        <Link to="/" className="text-orange-500 text-lg font-semibold font-sans">
          Netsi's Kitchen
        </Link>
      </div>
    <header className='bg-amber-400'>
      <nav className="bg- flex items-center justify-center px-4 py-2">
        
        
<div className="md:hidden">
  <button
    type="button"
    className="text-orange-800 hover:text-black focus:outline-none focus:text-orange-400"
    onClick={handleMobileMenuToggle}
  >
    <svg
      className="h-6 w-6 fill-current"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      {isMobileMenuOpen ? (
        <path
          d="M6 18L18 6M6 6l12 12"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : (
        <path
          d="M4 6h16M4 12h16M4 18h16"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      )}
    </svg>
  </button>
</div>


        <div
        className={`${
          isMobileMenuOpen ? 'flex flex-col' : 'hidden'
        } md:flex md:flex-row md:ml-4 md:justify-center`}
        >
          <Link
            to="/"
            className="text-orange-800 font-semibold  hover:text-white px-3 py-2 rounded-md text-lg"
          >
            Home
          </Link>
          <Link
            to="about"
            className="text-orange-800 font-semibold  hover:text-white px-3 py-2 rounded-md text-lg"
          >
            About Us
          </Link>
          <Link
            to="menu"
            className="text-orange-800 font-semibold  hover:text-white px-3 py-2 rounded-md text-lg"
          >
            Our Menu
          </Link>
          <Link
            to="catering"
            className="text-orange-800 font-semibold  hover:text-white px-3 py-2 rounded-md text-lg"
          >
            Catering Service
          </Link>
          <Link
            to="popup"
            className="text-orange-800 font-semibold  hover:text-white px-3 py-2 rounded-md text-lg"
          >
            Pop Up Events
          </Link>
        </div>
      </nav>
    </header>
    </div>
  );
};

export default Header;
